import React, { FC, ReactNode } from 'react';

import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';

import { StartOrderEmptyState } from './start-order-empty-state';

interface IOrdersEmptyProps {
  children?: ReactNode;
}

const OrdersEmpty: FC<React.PropsWithChildren<IOrdersEmptyProps>> = ({ children }) => {
  return (
    <Box style={styles.wrapper}>
      <Box style={styles.startOrderWrapper}>
        <StartOrderEmptyState />
      </Box>
      {children}
    </Box>
  );
};

const styles = StyleSheet.create({
  startOrderWrapper: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  wrapper: {
    flexGrow: 1,
  },
});

export default OrdersEmpty;
